<template>
  <div class="container topicSelection">
    <v-data-table
        v-model="selected"
        :sort-by="sortBy"
        show-select :headers="tableHeaders" :items="segmentData" class="table" style="padding-left: 30px; padding-right: 30px; overflow: hidden">
      <template v-slot:[`header.data-table-select`]>Selected</template>
    </v-data-table>

  </div>
  <v-btn icon="mdi-skip-forward" class="stopButton" @click="next"></v-btn>
  <v-btn icon="mdi-skip-backward" class="backButton" @click="back"></v-btn>
</template>

<script>
import {
  loadWorkshop, saveSelectedTopics,
} from "@/workshop/workshopFunctions";
import segmentData from '../data/segment.json'

export default {
  name: "workshopTopicSelection",
  components: {},
  data() {
    return {
      selected: [],
      sortBy: [{ key: 'potential', order:'desc'}],
      workshopData: [],
      segmentData: [],
      tableHeaders: [
        {
          title: 'Name',
          align: 'start',
          key: 'text.en.name'
        },
        {
          title: 'Category',
          align: 'start',
          key: 'category'
        },
        {
          title: 'Potential',
          align: 'end',
          key: 'potential'
        },
        {
          title: 'Where we want to be',
          align: 'end',
          key: 'voteWhereWantToBe'
        },
        {
          title: 'Where we are',
          align: 'end',
          key: 'voteWhereWeAre'
        },
      ],
    }
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
    workshopId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    loadWorkshop(this.customerId, this.workshopId).then(res => {
      this.workshopData = res;
      this.loadTextWithVoteAndPotential();
    });
  },
  methods: {
    loadTextWithVoteAndPotential(){
      const data = []
      for (const cat of [...segmentData]) {
        for(const subcat of cat.children){
         if(Object.keys(this.workshopData.results).includes(subcat.id)) {
           let result = this.workshopData.results[subcat.id];
           data.push({ category: cat.text.en.name,voteWhereWantToBe: result.voteWhereWantToBe,voteWhereWeAre: result.voteWhereWeAre, potential: result.voteWhereWantToBe - result.voteWhereWeAre,...subcat});
          }

        }
      }
      this.segmentData = data;
      this.segmentData.sort((x, y) => {
        // Zuerst nach 'a' absteigend sortieren
        if (x.potential !== y.potential) {
          return y.potential - x.potential;
        }
        // Wenn 'a' gleich ist, dann nach 'b' absteigend sortieren
        return x.voteWhereWantToBe - y.voteWhereWantToBe;
      });
      console.log(this.workshopData)
      if(this.workshopData.selectedTopics != undefined){
        this.selected = this.workshopData.selectedTopics;
      } else {
        this.selected = this.segmentData.slice(0, 3).map(x => x.id);
      }
      console.log("mi", this.selected)
    },
    next(){
      saveSelectedTopics(this.workshopId, this.selected)
      this.$emit('next', this.selected);
    },
    back(){
      saveSelectedTopics(this.workshopId, this.selected)
      this.$emit('back', this.selected);
    }
  }
};
</script>

<style>
.container {
  width: fit-content;
  margin: 60px auto;
}

.backButton {
  position: absolute;
  top: 20px;
  right: 85px;
}



.topicSelection .v-table tr th:nth-child(1),
.topicSelection .v-table tr td:nth-child(1) {
  width: 100px !important;
}

.topicSelection .v-table tr th:nth-child(2),
.topicSelection .v-table tr td:nth-child(2) {
  width: 300px;
}

.topicSelection .v-table tr th:nth-child(3),
.topicSelection .v-table tr td:nth-child(3) {
  text-align: left;
}

.topicSelection .v-table tr th:nth-child(5),
.topicSelection .v-table tr td:nth-child(5) {
  width: 150px;
  text-align: right;
}

</style>
